import { Component, OnInit } from "@angular/core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faCaretCircleDown } from "@fortawesome/pro-solid-svg-icons";
import { GlobalHeaderDataService } from "../global-header-data.service";
import { SetSSOSettings } from "src/app/store/actions/global-header.actions";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { environment } from "../../../environments/environment";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-global-sso-menu",
  templateUrl: "./global-sso-menu.component.html",
  styleUrls: ["./global-sso-menu.component.scss"],
})
export class GlobalSsoMenuComponent implements OnInit {
  faCaretDown = faCaretDown;
  faCaretCircleDown = faCaretCircleDown;
  showMenu = false;
  inboxLink = "";
  modelManagementLink = "";
  oneAccessLink = "";
  assetUrl = environment.assetUrl;

  constructor(
    private dataService: GlobalHeaderDataService,
    private appService: AppService,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    this.dataService.getIsActive().subscribe(
      (data) => {
        for (let i = 0; i < data.length; i++) {
          if (!data[i].status) {
            this.showMenu = true;
            if (i === 0) {
              this.modelManagementLink = data[i].url;
            } else if (i === 1) {
              this.oneAccessLink = data[i].url;
            }
          }
        }
        const ssoObj = {
          modelManagementLink: this.modelManagementLink,
          oneAccessLink: this.oneAccessLink,
        };
        this.store.dispatch(
          new SetSSOSettings(this.appService.deepClone(ssoObj)),
        );
      },
      (error) => {
        this.showMenu = false;
        console.error(error);
      },
    );
  }
}
